import Authenticate from '@/views/client/Authenticate';
import SendEmailLink from '@/views/client/SendEmailLink';
import Unauthenticated from '@/views/client/Unauthenticated';
import ClientHome from '@/views/client/Home';
import Citizenship from '@/views/client/Citizenship';
import LegalName from '@/views/client/LegalName';
import LegalAddress from '@/views/client/LegalAddress';
import SSN from '@/views/client/SSN';
import DateOfBirth from '@/views/client/DateOfBirth';
import AlternatePhone from '@/views/client/AlternatePhone';
import EmploymentStatus from '@/views/client/EmploymentStatus';
import EmploymentStatus2 from '@/views/client/EmploymentStatus2';
import Business from '../views/client/Business.vue';
import AnnualIncome from '../views/client/AnnualIncome.vue';
import WealthSource from '../views/client/WealthSource.vue';
import PolticallyExposedPerson from '../views/client/PolticallyExposedPerson.vue';
import CompanyAddress from '@/views/client/CompanyAddress';
import JobDescription from '@/views/client/JobDescription';
import CompanyOfficial from '@/views/client/CompanyOfficial';
import BeneficialInterest from '@/views/client/BeneficialInterest';
import InheritedIRA from '@/views/client/InheritedIRA.vue';
import TrustAccount from '@/views/client/TrustAccount.vue';
import EntityAccount from '@/views/client/EntityAccount.vue';
import TrustInfo from '@/views/client/TrustInfo.vue';
import Trustees from '@/views/client/Trustees.vue';
import Grantors from '@/views/client/Grantors.vue';
import EntityInfo from '@/views/client/EntityInfo.vue';
import AuthorizedSigners from '@/views/client/AuthorizedSigners.vue';
import PrimaryBeneficiaries from '@/views/client/PrimaryBeneficiaries';
import ContingentBeneficiaries from '@/views/client/ContingentBeneficiaries';
import ConsolidatedStatement from '@/views/client/ConsolidatedStatement';
import CustomQuestions from '@/views/client/CustomQuestions';
import StatementSubmitted from '@/views/client/transitions/StatementSubmited';
import TransitionsEmailRegister from '@/views/client/transitions/EmailRegister';
import Finish from '@/views/client/Finish';
import StatementUpload from '@/views/client/transitions/StatementUpload';
// Pershing components
import PershingPrimaryBeneficiaries from '@/views/client/pershing/PershingPrimaryBeneficiaries';
import PershingContingentBeneficiaries from '@/views/client/pershing/PershingContingentBeneficiaries';
import PershingTrustInfo from '@/views/client/pershing/PershingTrustInfo';
import PershingInheritedIRA from '@/views/client/pershing/PershingInheritedIRA';
import PershingEmployerRisk from '@/views/client/pershing/PershingEmployerRisk';
import PershingMaritalStatus from '@/views/client/pershing/PershingMaritalStatus';
import PershingJointAccountInfo from '@/views/client/pershing/PershingJointAccountInfo';
import PershingKYC from '@/views/client/pershing/PershingKYC';
import PershingEntityInfo from '@/views/client/pershing/PershingEntityInfo.vue';
import PershingCompanyAddress from '@/views/client/pershing/PershingCompanyAddress';
import PershingConsolidatedStatement from '@/views/client/pershing/PershingConsolidatedStatement.vue';
import { MENUS } from '@/common/constants';

const routes = [
  {
    path: "/statement-upload/:transitionId",
    name: MENUS.TRANSITIONS.STATEMENT_UPLOAD.id,
    props: (route) => ({
      transitionId: route.params.transitionId,
      relatesTo: route.query.relatesTo,
    }),
    component: StatementUpload,
    meta: {
      breadcrumb: "",
    },
  },
  {
    path: "/email-register/:transitionId",
    name: MENUS.TRANSITIONS.EMAIL_REGISTER.id,
    component: TransitionsEmailRegister,
    props: (route) => ({
      transitionId: route.params.transitionId,
      relatesTo: route.query.relatesTo,
    }),
    meta: {
      breadcrumb: "",
    },
  },
  {
    path: "/statement-submitted",
    name: MENUS.TRANSITIONS.STATEMENT_SUBMITTED.id,
    component: StatementSubmitted,
    meta: {
      breadcrumb: "",
    },
  },
  // Main
  {
    path: "/interview/:token?",
    name: MENUS.INTERVIEW.AUTHENTICATE.id,
    component: Authenticate,
    props: true,
  },
  {
    path: "/interview/:token/send-email",
    name: MENUS.INTERVIEW.SEND_EMAIL_LINK.id,
    component: SendEmailLink,
    props: true,
  },
  {
    path: "/interview-exited",
    name: MENUS.INTERVIEW.UNAUTHENTICATED.id,
    component: Unauthenticated,
    props: true,
  },
  {
    path: "/client-interview/",
    name: MENUS.CLIENT.HOME.id,
    component: ClientHome,
    meta: { breadcrumb: "" },
    children: [
      {
        path: "/client-interview/citizenship",
        name: MENUS.CLIENT.CITIZENSHIP.id,
        component: Citizenship,
      },
      {
        path: "/client-interview/legal-name",
        name: MENUS.CLIENT.LEGAL_NAME.id,
        component: LegalName,
      },
      {
        path: "/client-interview/legal-address",
        name: MENUS.CLIENT.LEGAL_ADDRESS.id,
        component: LegalAddress,
      },
      {
        path: "/client-interview/ssn",
        name: MENUS.CLIENT.SSN.id,
        component: SSN,
      },
      {
        path: "/client-interview/date-of-birth",
        name: MENUS.CLIENT.DOB.id,
        component: DateOfBirth,
      },
      {
        path: "/client-interview/alternate-phone",
        name: MENUS.CLIENT.ALTERNATE_PHONE.id,
        component: AlternatePhone,
      },
      {
        path: "/client-interview/employment-status",
        name: MENUS.CLIENT.EMPLOYMENT_STATUS.id,
        component: EmploymentStatus,
      },
      {
        path: "/client-interview/employment-status-2",
        name: MENUS.CLIENT.EMPLOYMENT_STATUS_2.id,
        component: EmploymentStatus2,
      },
      {
        path: "/client-interview/business-line",
        name: MENUS.CLIENT.BUSINESS.id,
        component: Business,
      },
      {
        path: "/client-interview/annual-income",
        name: MENUS.CLIENT.ANNUAL_INCOME.id,
        component: AnnualIncome,
      },
      {
        path: "/client-interview/wealth-source",
        name: MENUS.CLIENT.WEALTH_SOURCE.id,
        component: WealthSource,
      },
      {
        path: "/client-interview/is-pep",
        name: MENUS.CLIENT.POLITICALLY_EXPOSED_PERSON.id,
        component: PolticallyExposedPerson,
      },
      {
        path: "/client-interview/company-address",
        name: MENUS.CLIENT.COMPANY_ADDRESS.id,
        component: CompanyAddress,
      },
      {
        path: "/client-interview/pershing-company-address",
        name: MENUS.CLIENT.PERSHING_COMPANY_ADDRESS.id,
        component: PershingCompanyAddress,
      },
      {
        path: "/client-interview/job-description",
        name: MENUS.CLIENT.JOB_DESCRIPTION.id,
        component: JobDescription,
      },
      {
        path: "/client-interview/company-official",
        name: MENUS.CLIENT.COMPANY_OFFICIAL.id,
        component: CompanyOfficial,
      },
      {
        path: "/client-interview/beneficial-interest",
        name: MENUS.CLIENT.BENEFICIAL_INTEREST.id,
        component: BeneficialInterest,
      },
      {
        path: "/client-interview/account-primary-beneficiaries/:name/:label",
        name: MENUS.CLIENT.ACCOUNT_PRIMARY_BENEFICIARIES.id,
        props: true,
        component: PrimaryBeneficiaries,
      },
      {
        path: "/client-interview/account-contingent-beneficiaries/:name/:label",
        name: MENUS.CLIENT.ACCOUNT_CONTINGENT_BENEFICIARIES.id,
        props: true,
        component: ContingentBeneficiaries,
      },
      {
        path: "/client-interview/decedent/:name/:label",
        name: MENUS.CLIENT.INHERITEDIRA.id,
        props: true,
        component: InheritedIRA,
      },
      {
        path: "/client-interview/trust-account/:name/:label",
        name: MENUS.CLIENT.TRUST_ACCOUNT.id,
        props: true,
        component: TrustAccount,
      },
      {
        path: "/client-interview/entity-account/:name/:label",
        name: MENUS.CLIENT.ENTITY_ACCOUNT.id,
        props: true,
        component: EntityAccount,
      },
      {
        path: "/client-interview/trust-info/:name/:label",
        name: MENUS.CLIENT.TRUST_INFO.id,
        props: true,
        component: TrustInfo,
        meta: { breadcrumb: "Trust Information" },
      },
      {
        path: "/client-interview/trustees/:name/:label",
        name: MENUS.CLIENT.TRUSTEES.id,
        props: true,
        component: Trustees,
        meta: { breadcrumb: "Trustees" },
      },
      {
        path: "/client-interview/grantors/:name/:label",
        name: MENUS.CLIENT.GRANTORS.id,
        props: true,
        component: Grantors,
        meta: { breadcrumb: "Grantors" },
      },
      {
        path: "/client-interview/entity-info/:name/:label",
        name: MENUS.CLIENT.ENTITY_INFO.id,
        props: true,
        component: EntityInfo,
        meta: { breadcrumb: "Entity Information" },
      },

      // Pershing-specific Entity Info (same position in flow)
      {
        path: "/client-interview/pershing-entity-info/:name/:label",
        name: MENUS.CLIENT.PERSHING_ENTITY_INFO.id,
        props: true,
        component: PershingEntityInfo,
        meta: { breadcrumb: "Entity Information" },
      },

      {
        path: "/client-interview/authorized-signers/:name/:label",
        name: MENUS.CLIENT.AUTHORIZED_SIGNERS.id,
        props: true,
        component: AuthorizedSigners,
        meta: { breadcrumb: "Authorized Signers" },
      },
      {
        path: "/client-interview/consolidated-statement",
        name: MENUS.CLIENT.CONSOLIDATED_STATEMENT.id,
        component: ConsolidatedStatement,
      },
      {
        path: "/client-interview/pershing-consolidated-statement",
        name: MENUS.CLIENT.PERSHING_CONSOLIDATED_STATEMENT.id,
        component: PershingConsolidatedStatement,
      },
      {
        path: "/client-interview/custom-question/:questionId",
        name: MENUS.CLIENT.CUSTOM_QUESTIONS.id,
        props: true,
        component: CustomQuestions,
      },
      // Pershing routes
      {
        path: "/client-interview/pershing-primary-beneficiaries/:name/:label",
        name: MENUS.CLIENT.PERSHING_PRIMARY_BENEFICIARIES.id,
        props: true,
        component: PershingPrimaryBeneficiaries,
      },
      {
        path: "/client-interview/pershing-contingent-beneficiaries/:name/:label",
        name: MENUS.CLIENT.PERSHING_CONTINGENT_BENEFICIARIES.id,
        props: true,
        component: PershingContingentBeneficiaries,
      },
      {
        path: "/client-interview/pershing-trust-info/:name/:label",
        name: MENUS.CLIENT.PERSHING_TRUST_INFO.id,
        props: true,
        component: PershingTrustInfo,
      },
      {
        path: "/client-interview/pershing-decedent/:name/:label",
        name: MENUS.CLIENT.PERSHING_DECEDENT.id,
        props: true,
        component: PershingInheritedIRA,
      },
      {
        path: "/client-interview/pershing-employer-risk",
        name: MENUS.CLIENT.PERSHING_EMPLOYER_RISK.id,
        component: PershingEmployerRisk,
      },
      {
        path: "/client-interview/pershing-marital-status",
        name: MENUS.CLIENT.PERSHING_MARITAL_STATUS.id,
        props: true,
        component: PershingMaritalStatus,
      },
      {
        path: "/client-interview/pershing-joint-account-info/:name/:label",
        name: MENUS.CLIENT.PERSHING_JOINT_ACCOUNT_INFO.id,
        props: true,
        component: PershingJointAccountInfo,
      },
      {
        path: "/client-interview/pershing-kyc/:name/:label",
        name: MENUS.CLIENT.PERSHING_KYC.id,
        props: true,
        component: PershingKYC,
      },
      {
        path: "/client-interview/finish",
        name: MENUS.CLIENT.FINISH.id,
        props: true,
        component: Finish,
      },
    ],
  },
];

export default routes;
